module.exports = __webpack_public_path__ + "dda4eebaced4e307527aa5f44164035e.pdf";